import AppTour from 'app/tour/AppTour';
import { TourStep, TourStepRaw } from 'app/tour/index';
import TourStepLifeCycle from 'app/tour/TourStepLifeCycle';

export default class MetricViewerTour extends AppTour {
    static tourName: string = 'metric-viewer';
    rawSteps: Array<TourStepRaw> = [
        {
            target: '[data-test="announcement-edit-42"]',
            content: 'Here you can see Metric Chart!',
            placement: 'left',
        },
        {
            target: '.highcharts-container',
            content: 'Here you can see Metric Chart!',
            placement: 'right',
        },
        {
            target: '[data-test="add_expert_analysis_button"]',
            content: 'Here you can see Metric Chart!',
            placement: 'right',
        },
        {
            target: '[data-test="wall_post_button"]',
            content: 'Here you can see Metric Chart!',
            placement: 'bottom',
        },
        {
            target: '[data-test="wall_post_button"]',
            content: 'Here you can see Metric Chart!',
            placement: 'top',
        },
        {
            target: '[data-test="alert-subscription_button"]',
            content: 'Here you can left your very important comment!',
            placement: 'left',
        },
        {
            target: '[data-test="left_axis_mask"]',
            content: 'Super Select!',
            disableScrolling: true,
            lifeCycle: new (class extends TourStepLifeCycle {
                async onBeforeStart(step: TourStep, backward: boolean = false): Promise<any> {
                    const element = document.getElementById('overlay-metrics');
                    if (element) {
                        element.click();
                    }
                    return super.onBeforeStart(step, backward);
                }
            })(this),
        },
    ];
}
